import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import momentLocalizer from 'react-widgets-moment';
import store from './store';
import AppContainer from './containers/App';
import './i18n';
import { applyFavicon } from './logic/favicon';
momentLocalizer();

const container = document.getElementById('root'); // Changed from 'app' to 'root'
const root = createRoot(container);

const VARIANT = (process.env.REACT_APP_VARIANT || '').toLowerCase();
document.title = VARIANT === 'urclyrd' ? 'Urclyrd' : 'Podesubir';

applyFavicon();

root.render(
  <Provider store={store}>
    <Router>
      <AppContainer />
    </Router>
  </Provider>
);
